import { render } from "./Static.vue?vue&type=template&id=6e480ae8"
import script from "./Static.vue?vue&type=script&lang=ts"
export * from "./Static.vue?vue&type=script&lang=ts"

import "./Static.vue?vue&type=style&index=0&id=6e480ae8&lang=scss"
script.render = render

export default script